import { devSettingsSchema } from '../devSettings.schema';
import { DEV_SETTINGS_STORAGE_KEY } from '../devSettings.types';
import type { DevSettings } from '../devSettings.types';

export const getStoredDevSettings = (): DevSettings | null => {
  const stored = window.localStorage.getItem(DEV_SETTINGS_STORAGE_KEY);

  if (!stored) {
    return null;
  }

  try {
    const parsed = JSON.parse(stored);

    return devSettingsSchema.parse(parsed);
  } catch {
    return null;
  }
};
